// extracted by mini-css-extract-plugin
export default {"root":"BlockListings_root__hRPsl","media":"BlockListings_media__Yk7eo","text":"BlockListings_text__5Oe2J"};